// Uniform
var _componentUniform = function($context) {
    if (!$().uniform) {
        console.warn('Warning - uniform.min.js is not loaded.');
        return;
    }
    
    $context = $context instanceof jQuery ? $context : $(document);

    // Default initialization
    $context.find('.form-check-input-styled').uniform();

    //
    // Contextual colors
    //

    // Primary
    $context.find('.form-check-input-styled-primary').uniform({
        wrapperClass: 'border-primary-600 text-primary-800'
    });

    // Danger
    $context.find('.form-check-input-styled-danger').uniform({
        wrapperClass: 'border-danger-600 text-danger-800'
    });

    // Success
    $context.find('.form-check-input-styled-success').uniform({
        wrapperClass: 'border-success-600 text-success-800'
    });

    // Warning
    $context.find('.form-check-input-styled-warning').uniform({
        wrapperClass: 'border-warning-600 text-warning-800'
    });

    // Info
    $context.find('.form-check-input-styled-info').uniform({
        wrapperClass: 'border-info-600 text-info-800'
    });

    // Custom color
    $context.find('.form-check-input-styled-custom').uniform({
        wrapperClass: 'border-indigo-600 text-indigo-800'
    });
};

// Switchery
var _componentSwitchery = function($context) {
    if (typeof Switchery == 'undefined') {
        console.warn('Warning - switchery.min.js is not loaded.');
        return;
    }

    // Initialize multiple switches
    var context = $context instanceof jQuery ? $context.get(0) : document;
    var elems = Array.prototype.slice.call(context.querySelectorAll('.form-check-input-switchery'));
    
    elems.forEach(function(html) {
      var switchery = new Switchery(html);
    });
};

// Bootstrap switch
var _componentBootstrapSwitch = function($context) {
    if (!$().bootstrapSwitch) {
        console.warn('Warning - switch.min.js is not loaded.');
        return;
    }

    // Initialize
    ($context instanceof jQuery ? $context.find('.form-check-input-switch') : $('.form-check-input-switch')).bootstrapSwitch();
};

function init($context) {
    _componentUniform($context);
    _componentSwitchery($context);
    _componentBootstrapSwitch($context);
}


export const InputsCheckboxesRadios = {
    init
}